import React, { useEffect, useState } from 'react';
import StaticPageHeader from '../components/common/StaticPageHeader';
import CustomInput from '../components/common/CustomInput';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import TopAddress from '../components/TopAddress';
import { callGetWebservice, callPostWebservice } from '../hooks/api';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import '../assets/css/allpages.css';

const validationSchema = Yup.object({
	name: Yup.string().required('Name is required'),
	password: Yup.string().min(6, 'Password must be at least 6 characters'),
	confirm_password: Yup.string()
		.test('passwords-match', 'Passwords must match', function (value) {
			return !this.parent.password || value === this.parent.password;
		})
});

const MyAccount = () => {
	const [profile, setProfile] = useState({});
	const dispatch = useDispatch();
	const navigate = useNavigate();

	useEffect(() => {
		callGetWebservice('profile', {}, (response) => {
			setProfile(response.data);
		}, null, dispatch, navigate);
	}, []);

	useEffect(() => {
		const fetchedData = {
			name: profile.name || '',
			email: profile.email || '',
			login_type: profile.login_type,
			password: '',
			confirm_password: ''
		};
		formik.setValues(fetchedData);
	}, [profile]);

	const formik = useFormik({
		initialValues: { name: '', password: '', confirm_password: '' },
		validationSchema,
		onSubmit: (values, { setSubmitting }) => {
			callPostWebservice('profile', values, (response) => {
				setSubmitting(false);
				alert(response.message);
			}, (error) => {
				setSubmitting(false);
				formik.setErrors({ email: error.errMessage });
			});
		},
	});

	return (
		<div className="static-page-wrapper bg-light min-vh-100 pb-5">
			<StaticPageHeader title="My Account" />

			<div className="container static-page-container mt-4">
				<div className="row align-items-start mt-1">
					<TopAddress />
					<div className="col-12 col-md-8">
						<div className="bg-white border shadow-sm p-4 p-md-5 mb-4" style={{ borderRadius: '12px' }}>
							<h3 className="fw-bold text-dark mb-2" style={{ fontSize: '1.75rem' }}>Account Settings</h3>
							<p className="text-secondary mb-5">Manage your profile information and security</p>
							
							<form className="row g-4" onSubmit={formik.handleSubmit}>
								<div className="col-12">
									<CustomInput label="Full Name *" name="name" placeholder="Enter your name" formik={formik} />
								</div>

								<div className="col-12">
									<div className="custom-input-container">
										<label className="custom-input-label text-dark fw-medium">Email Address</label>
										<input type="text" className="form-control py-2" value={profile?.email || ''} disabled={true} style={{ backgroundColor: '#f9f9f9', color: '#888', borderStyle: 'dashed' }} />
										<small className="text-muted mt-2 d-block"><i className="fas fa-lock mr-1"></i> Email cannot be changed.</small>
									</div>
								</div>

								{profile.login_type === 'manual' && (
									<>
										<div className="col-12 col-md-6">
											<CustomInput label="New Password" name="password" type="password" placeholder="Minimum 6 characters" formik={formik} />
										</div>

										<div className="col-12 col-md-6">
											<CustomInput label="Confirm Password" name="confirm_password" type="password" placeholder="Repeat new password" formik={formik} />
										</div>
									</>
								)}

								<div className="col-12 mt-5">
									<button type="submit" className="btn btn-dark w-100 py-3 fw-medium shadow-sm transition-hover" style={{ borderRadius: '8px' }} disabled={formik.isSubmitting || !formik.isValid}>
										Save Profile Changes <i className="fas fa-check-circle ml-2"></i>
									</button>
								</div>
							</form>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default MyAccount;